
import { defuFn } from '/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
